import Tooltip, { tooltipClasses } from "@mui/material/Tooltip";
import { styled } from "@mui/material/styles";
import useColors from "../api/hooks/useColors";

const CustomToolTip = styled(({ className, style = null, ...props }) => (
  <Tooltip {...props} classes={{ popper: className }} arrow />
))(({ theme, style }) => {
  const colors = useColors();

  return {
    [`& .${tooltipClasses.tooltip}`]: {
      backgroundColor: theme.palette.common.white,
      color: colors.common_black,
      boxShadow: "0px 2px 6px " + colors.divider2,
      maxWidth: "400px",
      fontSize: 11,
      borderRadius: "6px",
      ...style,
    },
    [`& .${tooltipClasses.arrow}`]: {
      color: theme.palette.common.white,
      "&::before": {
        boxShadow: "0px 1px 2px 0px " + colors.box_shadow,
      },
    },
  };
});

export default CustomToolTip;
